export function ArrowDownIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.763604 0.563409C1.11508 0.211937 1.68492 0.211937 2.0364 0.563409L5 3.52702L7.9636 0.563409C8.31508 0.211937 8.88492 0.211937 9.2364 0.563409C9.58787 0.914881 9.58787 1.48473 9.2364 1.8362L5.6364 5.43621C5.28492 5.78768 4.71508 5.78768 4.3636 5.43621L0.763604 1.8362C0.412132 1.48473 0.412132 0.914881 0.763604 0.563409Z'
        fill='currentColor'
      />
    </svg>
  )
}
